export const hashes = {
  SEARCH_FORM: 'search-form',
  SEARCH_RESULT: 'search-result',
}
